import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { getUserDisplayMode } from 'domains/user';
import { Flex, Image, Link, PUBLIC } from 'UI';

const LOGO_LINK_HEIGHT = 64;

const LogoLink = styled.div`
  height: ${LOGO_LINK_HEIGHT}px;

  a {
    display: flex;
    height: 100%;
    align-items: center;
  }

  // Neutralize Ant Image inline baseline so the stacked logos stay vertically centered
  .ant-image,
  .ant-image-img {
    display: block;
  }
`;

const RpartStoreLogo = () => {
  const isR3Motrio = useSelector(getUserDisplayMode) === 'R3_MOTRIO';

  return (
    <LogoLink>
      <Link to={'/'}>
        <Flex direction={'column'} align={'center'} justify={'center'} gap={7}>
          <Image
            type={PUBLIC}
            src={'startup-logo-rpartstore.svg'}
            alt={'startup-logo-rpartstore'}
            dataCy={'rpart-store-logo'}
            height={12}
          />
          {isR3Motrio && (
            <Image type={PUBLIC} src={'renault-logo-motrio.svg'} alt={'renault-logo-motrio'} height={12} />
          )}
        </Flex>
      </Link>
    </LogoLink>
  );
};

export default RpartStoreLogo;
